import { FormikVehicleByProvingPicker } from 'components/VehicleListPicker/VehicleListPicker'
import { FieldStack, FieldStackItem, FormStack } from 'forms/FormStack'
import * as React from 'react'

export const ProvingDetailsExistingVehiclesForm: React.FC = () => {
  return (
    <FormStack>
      <FieldStack>
        <FieldStackItem
          name={'vehicles'}
          component={FormikVehicleByProvingPicker}
        />
      </FieldStack>
    </FormStack>
  )
}
